// extracted by mini-css-extract-plugin
export default {"linkBox":"zeqV18EEgUrCa4bcUNZx","link":"JlIgSc_SlsQKY9ZQEbcq","videoPreview":"z0r2c0OHEXHIWMRnJKmZ","dragHandle":"B8OFwwwF3HfkXbtcMCzJ"};